export const cultureDropdownRes = {
  selectLanguage: {
    is: 'Veldu tungumál',
    en: 'Select language',
    pl: 'Wybierz język',
  },
  language: {
    is: 'Tungumál',
    en: 'Language',
    pl: 'Język',
  },
};
